<template>
  <div class="flex py-1">
    <em
      class="custom-icons w-4 h-4 mr-0.5"
      :style="{
        ...icon,
        backgroundColor,
      }"
    >
    </em>
    <span class="max-w-60 overflow-ellipsis">{{ stateCard?.title || title }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import { getCardStatus } from '@/utilities/defaultCardStatuses';
import cardStatusType from '@/types/cardStatusType';
import { ResourceType } from '@/types/resources';

const { iconPath, getCustomIconStyle } = useCustomIcon();
const _this = getCurrentInstance()!.proxy as any;

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  cardId: {
    type: String,
    required: true,
  },
  status: {
    type: String,
    required: true,
  },
});

const stateCard = computed(() => _this.$store.getters.getCards[props.cardId] || {});

const icon = computed(() => {
  const isEpic = stateCard.value?.type === ResourceType.Epic;
  return getCustomIconStyle(
    iconPath(
      getCardStatus(stateCard.value?.status || props.status, isEpic)?.icon ||
        getCardStatus(cardStatusType.Backlog, isEpic).icon
    )
  );
});

const backgroundColor = computed(() => {
  return (
    stateCard.value?.list_color ||
    stateCard.value?.color ||
    getCardStatus(props.status)?.color ||
    getCardStatus(cardStatusType.Backlog).color
  );
});
</script>
